import { render, staticRenderFns } from "./ReimpresionCredencial.vue?vue&type=template&id=a24c554a"
import script from "./ReimpresionCredencial.vue?vue&type=script&lang=js"
export * from "./ReimpresionCredencial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports